import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Button,
  ButtonGroup,
  Card,
  Col,
  Container,
  Dropdown,
  Form,
  InputGroup,
  Row,
  Stack,
} from "react-bootstrap";
import { saveAs } from "file-saver";
import {
  GetReviewerRecordList,
} from "../../../services/RecordReviewerAPI";
import {
  downloadZipFileForHeader,
} from "../../../services/UploadRecordsApi";
import ExcelJS from "exceljs";
import autoTable from "jspdf-autotable";
import jsPDF from "jspdf";
import DateRangePicker from "../../../common/CustomDateRangePicker";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../redux/Store";
import {
  CASE_STAGE_STATUS,
  HISTORIAN_SUMMARY_CODES,
  RECORD_REVIEWER_SUMMARY_CODES,
  ROR_STATUS,
} from "../../../common/Constant";
import HistorianActionDrawer from "../Historian/components/HistoriansActionDrawer";
import { RecordReviewerHeader } from "./actions/constants";
import {
  getRecordReviewerCardSearch,
  getRecordReviewerSimpleSearch,
} from "../../../services/RecordReviewerAPI";
import RecordReviewerEditableTable from "./components/RecordReviewerEditableTable";
import AppointmentActionsDropdown from "../../../common/AppointmentActionsDropdown";
import RecordReviewerAddNotes from "./components/RecordReviewerAddNotes";
import AssignToRecordReviewer from "./components/AssignToRecordReviewer";
import RORUploadRecordTabIndex from "./components/RecordReviewerUploadRecord/RORUploadRecordTabIndex";
import CustomPagination from "../../../common/Pagination";
import TableRowsPerPage from "../../../common/TableRowsPerPage";
import RecordReviewerCommonDrawer from "./components/RecordReviewerCommonDrawer";
import Loader from "../../../common/Loader";
import Snackbar from "../../../common/Snackbar";
import { getDownloadFileForPopUpDetails } from "../../../services/UploadRecordsApi";
import UploadStatusFloatingIcon from "../../../common/UploadStatusFloatingIcon";
import useAnimatedCounter from "../useAnimatedCounter";
import {
  setIsDashboard,
  setNewCaseInFoID,
} from "../../../redux/slice/CaseHeaderSlice";
import { useNavigate, useLocation } from "react-router-dom";

interface EditorDashboardProps {
  setShowMainHeader: React.Dispatch<React.SetStateAction<boolean>>;
}

const RecordReviewerDashboard: React.FC<EditorDashboardProps> = ({
  setShowMainHeader,
}) => {
  const allowedFeatures = useSelector(
    (state: RootState) => state.featureAccess.allowedFeatures,
  );
  const [loading, setLoading] = useState<boolean>(false);
  const inputRef = useRef<HTMLInputElement | null>(null);
  const [searchQuery, setSearchQuery] = useState<string>("");
  const today = new Date();
  const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
  const lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);
  const [computedMinDate, setComputedMinDate] = useState<Date | undefined>();
  const [computedMaxDate, setComputedMaxDate] = useState<Date | undefined>();
  const [selectedAction, setSelectedAction] = useState<string | number>("");
  const [recordReviewerData, setRecordReviewerData] = useState<any[]>([]);
  const [exportrorData, setexportrorData] = useState<any[]>([]);
  const [selectedCaseId, setSelectedCaseId] = useState<number | null>(null);
  const loggedInUserid = useSelector((state: RootState) => state.auth.userid);
  const [activeFilter, setActiveFilter] = useState(
    RECORD_REVIEWER_SUMMARY_CODES.OVERDUE_TODAY,
  );
  const [activeCard, setActiveCard] = useState<string>("Overdue");
  const [activeSubCard, setActiveSubCard] = useState<string>("Today");
  const [activeListName, setActiveListName] = useState<string>(
    "Overdue List (Today)",
  );

  const [drawerTitle, setDrawerTitle] = useState("");
  const [showActionDrawer, setShowActionDrawer] = useState(false);
  const [pendingOverdueCount, setPendingOverdueCount] = useState<string>("");
  const [todayOverdueCount, setTodayOverdueCount] = useState<string>("");
  const [overdueCount, setOverdueCount] = useState<string>("");
  const [allReports, setAllReports] = useState<string>("");
  const [pendingReview, setPendingReview] = useState<string>("");
  const [completedReview, setCompletedReview] = useState<string>("");
  const [totalAppointmentCancelled, setTotalAppointmentCancelled] =
    useState<string>("");
  const [draftReview, setDraftReview] = useState<string>("");
  const [rorNotInitiatedCount, setRorNotInitiatedCount] = useState<string>("");
  const [notScheduledOverdue, setNotScheduledOverdue] = useState<string>("");
  const [exceptionCount, setExceptionCount] = useState<string>("");
const [inReviewCount, setInReviewCount] = useState<string>("");
  const [selectedIds, setSelectedIds] = useState<string[]>([]);
  const [selectAll, setSelectAll] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState<any[]>([]);
  const [qmeScheduleId, setqmeScheduleId] = useState<Number>();

  const [totalRows, setTotalRows] = useState<any>("");
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [itemsPerPage, setItemsPerPage] = useState<number>(15);
  const [totalPages, setTotalPages] = useState<number>(1);
  const [sortColumn, setSortColumn] = useState<string>("");
  const [sortOrder, setSortOrder] = useState<string>("DESC");

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [error, setError] = useState("");

  const [dateRange, setDateRange] = useState<
    [Date | undefined, Date | undefined]
  >([firstDayOfMonth, lastDayOfMonth]);

  const handleDateRangeChange = (newRange: [Date | null, Date | null]) => {
    const [start, end] = newRange;
    setDateRange([start ?? undefined, end ?? undefined]);
  };

  useEffect(() => {
    const min = new Date(today);
    min.setFullYear(today.getFullYear() - 1);

    const max = new Date(today);
    max.setFullYear(today.getFullYear() + 1);

    setComputedMinDate(min);
    setComputedMaxDate(max);
  }, []);

  const toLocalISOString = (date: Date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const getRecordReviewerScheduleData = async (
    query: string = "",
    action: string = "",
    pageNo: number = 1,
    pageSize: number = itemsPerPage,
    key: string = sortColumn,
    direction: string = sortOrder,
  ) => {
    try {
      setLoading(true);

      const trimmedQuery = query?.trim();
      const [start, end] = dateRange;
      const payload = {
        searchString: trimmedQuery || "",
        startDate: start ? toLocalISOString(start) : "",
        endDate: end ? toLocalISOString(end) : "",
        actionTrigger: action,
        pageNo,
        pageSize,
        sortColumn: key,
        sortOrder: direction,
      };

      const response = await getRecordReviewerSimpleSearch(payload);
      setRecordReviewerData(response);
      setTotalPages(response[0]?.totalPages || 1);
      setTotalRows(response[0]?.totalCount || null);
      setSelectedCaseId(null);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const latestSummaryRequestId = useRef(0);

  const getRecordReviewerSummaryData = async (
    query: string = "",
    action: string = "",
  ) => {
    const requestId = ++latestSummaryRequestId.current;
    try {
      const trimmedQuery = query?.trim();
      const [start, end] = dateRange;
      const payload = {
        searchString: query || "",
        startDate: start ? toLocalISOString(start) : "",
        endDate: end ? toLocalISOString(end) : "",
      };

      const response = await getRecordReviewerCardSearch(payload);
      if (requestId !== latestSummaryRequestId.current) return;

      if (response) {
        setPendingOverdueCount(response?.nearDueCount ?? "");
        setTodayOverdueCount(response?.todayDueCount ?? "");
        setOverdueCount(response?.totalOverdueCount ?? "");
        setDraftReview(response?.totalDraftReviewCount ?? "");
        setPendingReview(response?.allPendingRORCount ?? "");
        setCompletedReview(response?.totalReviewCompletedCount ?? "");
        setTotalAppointmentCancelled(response?.totalApptCancelled ?? "");
        setRorNotInitiatedCount(response?.allPendingRORCount ?? "");
        setNotScheduledOverdue(response?.allPendingROROverDueCount ?? "");
        setExceptionCount(response?.totalExceptionCount ?? "");
        setAllReports(response?.allROR ?? "");
        setInReviewCount(response?.pendingReviewCount ?? "");
        setSelectedCaseId(null);
      }
    } catch (error) {
      if (requestId === latestSummaryRequestId.current) {
        console.error("Error fetching data:", error);
      }
      //console.error("Error fetching data:", error);
    } finally {
      // setLoading(false);
      if (requestId === latestSummaryRequestId.current) {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    const [start, end] = dateRange;

    if (start && end) {
      getRecordReviewerScheduleData(
        searchQuery,
        activeFilter,
        currentPage,
        itemsPerPage,
        sortColumn,
        sortOrder,
      );
    }
  }, [
    dateRange,
    searchQuery,
    currentPage,
    itemsPerPage,
    sortColumn,
    sortOrder,
  ]);

  useEffect(() => {
    const [start, end] = dateRange;

    if (start && end) {
      getRecordReviewerSummaryData(searchQuery, activeFilter);
    }
  }, [dateRange, searchQuery]);

  const debounce = (func: Function, delay: number) => {
    let timer: NodeJS.Timeout;
    return (...args: any[]) => {
      clearTimeout(timer);
      timer = setTimeout(() => func(...args), delay);
    };
  };

  const handleInputChange = debounce((value: string) => {
    if (value.length >= 3 || value.length === 0) {
      setSearchQuery(value);
      setCurrentPage(1);
    }
  }, 300);

  const handleResetFilters = () => {
    if (inputRef.current) {
      inputRef.current.value = "";
    }

    setSearchQuery("");
    // setTotalPages(1);
    // setCurrentPage(1);
    // setSortOrder("DESC");

    // // Reset date range to initial values
    // setDateRange([firstDayOfMonth, lastDayOfMonth]);

    // // Call API with default values
    // const filter = RECORD_REVIEWER_SUMMARY_CODES.OVERDUE_TODAY;

    // setActiveCard("Overdue");
    // setActiveSubCard("Today");
    // setActiveFilter(filter);
  };

  useEffect(() => {
    if (!activeFilter) return;

    const filterQuery = searchQuery || "";
    // First get summary
    getRecordReviewerSummaryData(filterQuery, activeFilter);

    // Then get search table
    getRecordReviewerScheduleData(
      filterQuery,
      activeFilter,
      1,
      itemsPerPage,
      sortColumn,
      "DESC",
    );
  }, [activeFilter, dateRange]);

  const NON_SELECTABLE_STAGES = [
    CASE_STAGE_STATUS.CLOSED,
    CASE_STAGE_STATUS.CANCELLED,
  ];

  const handleCheckboxSelect = (selectedRows: any[]) => {
    const invalidRows = selectedRows.filter((row) =>
      NON_SELECTABLE_STAGES.includes(row?.caseStage),
    );

    if (invalidRows.length > 0) {
      const hasClosed = invalidRows.some(
        (row) => row.caseStage === CASE_STAGE_STATUS.CLOSED,
      );

      const hasCancelled = invalidRows.some(
        (row) => row.caseStage === CASE_STAGE_STATUS.CANCELLED,
      );

      let message = "Invalid case selection.";

      if (hasClosed && hasCancelled) {
        message = "Some cases are closed and some are cancelled.";
      } else if (hasClosed) {
        message = "Case has been closed.";
      } else if (hasCancelled) {
        message = "Case has been cancelled.";
      }

      setSnackbarMessage(message);
      setError("error");
      setSnackbarOpen(true);
    }

    const validRows = selectedRows.filter(
      (row) => !NON_SELECTABLE_STAGES.includes(row?.caseStage),
    );

    const ids = validRows
      ?.map((r: any) => String(r?.subjectQmeScheduleId))
      ?.filter(Boolean);

    setSelectedIds(ids);
    setqmeScheduleId(Number(ids));
    setSelectedRowData(validRows);
  };

  const [showAppointmentActionDrawer, setShowAppointmentActionDrawer] =
    useState(false);

     

  const allOptions = [
    // {
    //   value: "Assign to Reviewer",
    //   label: "Assign to Reviewer",
    // },
    {
      value: "Upload Records",
      label: "Upload / Review Report",
    },
    {
      value: "Add Notes",
      label: "Add Notes",
    },
    //  {
    //   value: "Download Records",
    //   label: "Download Records",
    // },
  ];

  const allOptionsForReviewCompleted = [
    {
      value: "Upload Records",
      label: "Review Report",
    },
    {
      value: "Add Notes",
      label: "Add Notes",
    },
    // {
    //   value: "Download Records",
    //   label: "Download Records",
    // },
  ];

  const allOptionsForMultipleSelect = [
    {
      value: "Assign to Reviewer",
      label: "Assign to Reviewer",
    },
  ];

  const isReviewCompleted = [
    ROR_STATUS.REVIEW_COMPLETED,
    ROR_STATUS.Review_Completed_Delayed,
  ].includes(selectedRowData?.[0]?.rorStatus);

  const hasAnyReviewCompleted = selectedRowData?.some((row: any) =>
    [ROR_STATUS.REVIEW_COMPLETED, ROR_STATUS.Review_Completed_Delayed].includes(
      row?.rorStatus,
    ),
  );

  const hideForMultipleCompleted =
    selectedIds?.length > 1 && hasAnyReviewCompleted;
  const showMultipleOptions = selectedIds?.length > 1 && !hasAnyReviewCompleted;
  const showCompletedSingle =
    selectedIds?.length === 1 && hasAnyReviewCompleted;
  const showRegularSingle = selectedIds?.length === 1 && !hasAnyReviewCompleted;

  const handleActionChange = (value: string | number) => {
    setSelectedAction(value);
    if (value === "Assign to Reviewer") {
      setDrawerTitle("Assign to Reviewer");
      setShowActionDrawer(true);
    }
    if (value === "Add Notes") {
      setDrawerTitle("Add Notes");
      setShowActionDrawer(true);
    }
    if (value === "Upload Records") {
      setShowMainHeader(false);
    }
  };

  const assignReviewer = () => {
    setSnackbarMessage("Assigned to reviewer successfully.");
    setError("success");
    setSnackbarOpen(true);
    handleSaveReviewerChanges();
  };

  const handleSaveReviewerChanges = () => {
    setSelectedIds([]);
    setSelectedRowData([]);
    setSelectAll(false);
    setShowMainHeader(true);
    setShowAppointmentActionDrawer(false);
    getRecordReviewerScheduleData(
      searchQuery,
      activeFilter,
      currentPage,
      itemsPerPage,
      sortColumn,
      sortOrder,
    );
    getRecordReviewerSummaryData(searchQuery, activeFilter);
  };

  const handlecloseActionDrawer = async () => {
    setShowActionDrawer(false);
    handleSaveReviewerChanges();
  };

  const handleActionDrawer = async () => {
    setShowActionDrawer(false);
  };
const handleDownloadALLRecords = async (
    datacategory: string,
    keyID: any,
  ) => {
    const listDataNew = await GetReviewerRecordList(
      selectedRowData[0]?.caseInfoId,
      keyID,
      selectedRowData[0]?.subjectQmeScheduleId,
    );
    const newIDs =
      listDataNew?.result?.map((item) => item.caseRecordHeaderID).join(",") ||
      "";
    handleDownloadProgress(`doc-${Date.now()}`, () =>
      downloadZipFileForHeader(newIDs, 1, ""),
    );
  };
  useEffect(() => {
        if (selectedAction === "Download Records") {
          handleDownloadALLRecords('',loggedInUserid);
            setSelectedAction("");
        }
      }, [selectedAction]);
  const refreshAppointmentData = () => {
    handleResetFilters();
    setSelectedIds([]);
    setSelectedRowData([]);
    setSelectAll(false);
    setShowMainHeader(true);
  };

  const handleCloseModalNew = () => {
    setShowActionDrawer(false);
    setSelectedAction("");
    handleSaveReviewerChanges();
  };

  const getBase64FromUrl = async (url: string): Promise<string> => {
    const res = await fetch(url);
    const blob = await res.blob();
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        if (typeof reader.result === "string") {
          resolve(reader.result);
        } else {
          reject("Failed to convert blob to base64");
        }
      };
      reader.onerror = () => reject("Failed to read blob");
      reader.readAsDataURL(blob);
    });
  };
  const handleExportExcel = async () => {
    try {
      const sheetName = "RORData";
      const selectedStatus = activeListName;
      const [startDate, endDate] = dateRange;

      // ---------- Date Label ----------
      const formatDate = (date: Date) =>
        date.toLocaleDateString("en-US", {
          month: "2-digit",
          day: "2-digit",
          year: "numeric",
        });

      let dateLabel = "";
      if (startDate && endDate && startDate.getTime() !== endDate.getTime()) {
        dateLabel = `${formatDate(startDate)} to ${formatDate(endDate)}`;
      } else {
        dateLabel = formatDate(startDate || new Date());
      }

      const title = `Appointments for ${selectedStatus} ${dateLabel}`;

      // ---------- Headers ----------
      const headers: string[] = [
        "Sr. No",
        ...RecordReviewerHeader.map((h: any) => h.label || h.name),
      ];

      // ---------- API ----------
      const trimmedQuery = searchQuery?.trim();
      const payload = {
        searchString: trimmedQuery,
        startDate: startDate ? toLocalISOString(startDate) : "",
        endDate: endDate ? toLocalISOString(endDate) : "",
        actionTrigger: activeFilter,
        pageNo: 1,
        pageSize: 100000,
        sortColumn: "",
        sortOrder: "DESC",
      };

      const response = await getRecordReviewerSimpleSearch(payload);

      if (!Array.isArray(response) || response.length === 0) {
        alert("No data available for export");
        return;
      }

      // ---------- Prepare Excel Data ----------
      const exportData: (string | number | null)[][] = response.map(
        (row: any, index: number) => {
          const rowArr: (string | number | null)[] = [];
          rowArr.push(index + 1);

          RecordReviewerHeader.forEach((header: any) => {
            let val = row[header.key] ?? "";

            if (header.key === "caseid" && typeof val === "string") {
              val = val.slice(-3);
            }

            rowArr.push(val);
          });

          return rowArr;
        },
      );

      // ---------- Excel ----------
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet(sheetName);

      // Title
      worksheet.mergeCells(1, 1, 1, headers.length);
      const titleCell = worksheet.getCell(1, 1);
      titleCell.value = title;
      titleCell.font = { bold: true, size: 14 };
      titleCell.alignment = { horizontal: "left" };

      // Header Row
      const headerRow = worksheet.addRow(headers);
      headerRow.font = { bold: true };

      // Data Rows
      exportData.forEach((rowArr) => {
        worksheet.addRow(rowArr);
      });

      // Column Width
      worksheet.columns.forEach((col, index) => {
        if (col) col.width = index === 0 ? 10 : 25;
      });

      // ---------- Download ----------
      const buffer = await workbook.xlsx.writeBuffer();
      const safeFileName = title.replace(/[\/\\:*?"<>|]/g, "-");

      saveAs(
        new Blob([buffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        }),
        `${safeFileName}.xlsx`,
      );
    } catch (error) {
      console.error("Excel Export Error:", error);
    }
  };

  const handleExportPDF = async () => {
    try {
      const selectedStatus = activeListName;
      const [startDate, endDate] = dateRange;

      // ---------- Date Label ----------
      const formatDate = (date: Date) =>
        date.toLocaleDateString("en-US", {
          month: "2-digit",
          day: "2-digit",
          year: "numeric",
        });

      let dateLabel = "";
      if (startDate && endDate && startDate.getTime() !== endDate.getTime()) {
        dateLabel = `${formatDate(startDate)} to ${formatDate(endDate)}`;
      } else {
        dateLabel = formatDate(startDate || new Date());
      }

      const title = `Appointments for ${selectedStatus} ${dateLabel}`;

      const logoBase64 = await getBase64FromUrl("/logo.png");

      // ---------- Headers ----------
      const headers: string[] = [
        "Sr. No",
        ...RecordReviewerHeader.map((h: any) => h.label || h.name),
      ];

      // ---------- API ----------
      const trimmedQuery = searchQuery?.trim();
      const payload = {
        searchString: trimmedQuery,
        startDate: startDate ? toLocalISOString(startDate) : "",
        endDate: endDate ? toLocalISOString(endDate) : "",
        actionTrigger: activeFilter,
        pageNo: 1,
        pageSize: 100000,
        sortColumn: "",
        sortOrder: "DESC",
      };

      const response = await getRecordReviewerSimpleSearch(payload);

      if (!Array.isArray(response) || response.length === 0) {
        alert("No data available for export");
        return;
      }

      // ---------- Table Data (IMPORTANT FIX) ----------
      const tableData: (string | number | null)[][] = response.map(
        (row: any, index: number) => {
          const obj: (string | number | null)[] = [];
          obj.push(index + 1);

          RecordReviewerHeader.forEach((header: any) => {
            let val = row[header.key] ?? "";

            if (header.key === "caseid" && typeof val === "string") {
              val = val.slice(-3);
            }

            obj.push(val);
          });

          return obj;
        },
      );

      // ---------- PDF ----------
      const doc = new jsPDF("landscape", "mm", "a4");
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();
      const margin = 10;

      autoTable(doc, {
        head: [headers],
        body: tableData,
        margin: { top: 28, left: 2 },
        styles: { fontSize: 9, cellPadding: 2, overflow: "linebreak" },
        tableWidth: pageWidth - margin,
        didDrawPage: (data) => {
          // ===== HEADER =====
          doc.setFontSize(12);
          doc.text("Medical Legal Portal", 2, 14);
          doc.addImage(logoBase64, "PNG", pageWidth - margin - 28, 5, 34, 12);

          // ===== TITLE =====
          doc.setFontSize(12);
          doc.text(title, 2, 22);

          // ===== FOOTER =====
          const footerY = pageHeight - 10;
          const now = new Date();
          const formattedDate = now.toLocaleString("en-US", {
            month: "2-digit",
            day: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: false,
          });

          const firstName = localStorage.getItem("firstname") ?? "";
          const lastName = localStorage.getItem("lastname") ?? "";

          const generatedByText = `Generated By & On - ${firstName} ${lastName} ${formattedDate}`;
          const pageNumberText = `Page No. ${
            data.pageNumber
          } of ${doc.getNumberOfPages()}`;

          doc.setDrawColor(0);
          doc.setLineWidth(0.1);
          doc.line(1, footerY - 5, pageWidth - 1, footerY - 5);

          doc.setFontSize(8);
          doc.text(generatedByText, 1, footerY);
          doc.text(
            pageNumberText,
            pageWidth - doc.getTextWidth(pageNumberText) - 1,
            footerY,
          );
        },
      });

      const safeFileName = title.replace(/[\/\\:*?"<>|]/g, "-");
      doc.save(`${safeFileName}.pdf`);
    } catch (error) {
      console.error("PDF Export Error:", error);
    }
  };

  const paginate = (pageNumber: number) => {
    setCurrentPage(pageNumber);
    getRecordReviewerScheduleData(
      searchQuery,
      activeFilter,
      pageNumber,
      itemsPerPage,
      sortColumn,
      sortOrder,
    );
  };

  const handleSortAction = (row: any) => {
    setSortColumn(row.key);
    setSortOrder(row.direction);
    getRecordReviewerScheduleData(
      searchQuery,
      activeFilter,
      currentPage,
      itemsPerPage,
      row.key,
      row.direction,
    );
  };

  const handleRowsPerPageChange = (value: number) => {
    setItemsPerPage(value);
    setCurrentPage(1);
  };

  // Calculate text for the range of entries currently visible
  const entriesText = !totalRows
    ? "Showing 0 of 0 entries"
    : `Showing ${(currentPage - 1) * itemsPerPage + 1} to ${Math.min(
        currentPage * itemsPerPage,
        totalRows,
      )} of ${totalRows} entries`;

  const getCurrentMonthRange = () => {
    const today = new Date();
    const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
    const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);
    return [firstDay, lastDay] as [Date, Date];
  };

  const handleCardClick = (filter: string) => {
    const current = 1;
    const perPage = 15;
    const column = "";
    const order = "DESC";

    setActiveFilter(filter);
    setCurrentPage(current);
    setItemsPerPage(perPage);
    setSortColumn(column);
    setSortOrder(order);
    setSelectedIds([]);
    setSelectedRowData([]);
    setSelectAll(false);
  };

  const handleResetDate = () => {
    const [start, end] = getCurrentMonthRange();
    setDateRange([start, end]);
  };

  const [downloadStatuses, setDownloadStatuses] = useState<any>({});

  const handleDownloadProgress = async (
    id: string,
    downloadFn: () => Promise<any>,
    fileName: string = "",
  ) => {
    setDownloadStatuses((prev: any) => ({
      ...prev,
      [id]: { fileName, progress: 0, isUploading: true },
    }));

    let progress = 0;
    const interval = setInterval(() => {
      progress += 10;
      if (progress >= 90) return;
      setDownloadStatuses((prev: any) => ({
        ...prev,
        [id]: { ...prev[id], progress },
      }));
    }, 300);

    try {
      await downloadFn();
      clearInterval(interval);
      setDownloadStatuses((prev: any) => ({
        ...prev,
        [id]: { ...prev[id], progress: 100, isUploading: false },
      }));
      setTimeout(() => {
        setDownloadStatuses((prev: any) => {
          const updated = { ...prev };
          delete updated[id];
          return updated;
        });
      }, 2000);
    } catch (error) {
      console.error("Download error:", error);
      clearInterval(interval);
      setDownloadStatuses((prev: any) => ({
        ...prev,
        [id]: { ...prev[id], isUploading: false },
      }));
    }
  };

  const handleDownloadSingleFileROR = (row: any) => {
    handleDownloadProgress(
      row?.recordDetailId,
      () =>
        getDownloadFileForPopUpDetails(
          row?.recordDetailId,
          row?.rorDocumentInfo,
        ),
      row?.rorDocumentInfo,
    );
  };

  const animatedPendingOverdue = useAnimatedCounter(pendingOverdueCount);

  const animatedTodayOverdue = useAnimatedCounter(todayOverdueCount);

  const animatedOverdue = useAnimatedCounter(overdueCount);

  const animatedAllReports = useAnimatedCounter(allReports);

  const animatedPendingReview = useAnimatedCounter(pendingReview);

  const animatedCompletedReview = useAnimatedCounter(completedReview);

  const animatedTotalAppointmentCancelled = useAnimatedCounter(
    totalAppointmentCancelled,
  );

  const animatedDraftReview = useAnimatedCounter(draftReview);

  const animatedRorNotInitiated = useAnimatedCounter(rorNotInitiatedCount);

  const animatedNotScheduledOverdue = useAnimatedCounter(notScheduledOverdue);

  const animatedExceptionCount = useAnimatedCounter(exceptionCount);

  const animatedInReview = useAnimatedCounter(inReviewCount);

  const dispatch = useDispatch();

  const [visibleHeaderIndex, setVisibleHeaderIndex] = useState<boolean>(false);

  const navigate = useNavigate();
  const location = useLocation();

  const handleCaseClick = (row: any) => {
    dispatch(setIsDashboard(true));
    dispatch(setNewCaseInFoID(row.caseInfoId));
    setVisibleHeaderIndex(true);
    sessionStorage.setItem("fromMyTodos", "true");
    navigate("/search-case", {
      state: {
        from: "mytodos",
        myTodosState: {
          searchQuery,
          dateRange,
          activeFilter,
          activeCard,
          activeSubCard,
          activeListName,
          currentPage,
          itemsPerPage,
          sortColumn,
          sortOrder,
        },
      },
    });
  };

  const resetToDefault = () => {
    setSearchQuery("");
    setDateRange([firstDayOfMonth, lastDayOfMonth]);
    setActiveFilter(RECORD_REVIEWER_SUMMARY_CODES.TOTAL_REVIEWS_PENDING);
     setActiveCard("ROR's");
                          setActiveListName("ROR's List (Pending)");
                          setActiveSubCard("RORP");
   
    setCurrentPage(1);
    setItemsPerPage(15);
    setSortColumn("");
    setSortOrder("DESC");
    if (inputRef.current) {
      inputRef.current.value = "";
    }
  };

  const hasInitialized = useRef(false);

  useEffect(() => {
    if (hasInitialized.current) return;
    hasInitialized.current = true;

    const cameFromMyTodos = sessionStorage.getItem("fromMyTodos");

    if (cameFromMyTodos === "true" && location.state?.from === "mytodos") {
      const s = location.state.myTodosState;

      setSearchQuery(s.searchQuery);
      setDateRange(s.dateRange);
      setActiveFilter(s.activeFilter);
      setActiveCard(s.activeCard);
      setActiveSubCard(s.activeSubCard);
      setActiveListName(s.activeListName);
      setCurrentPage(s.currentPage);
      setItemsPerPage(s.itemsPerPage);
      setSortColumn(s.sortColumn);
      setSortOrder(s.sortOrder);

      if (inputRef.current) {
        inputRef.current.value = s.searchQuery || "";
        getRecordReviewerSummaryData(s.searchQuery, activeFilter);
      }

      sessionStorage.removeItem("fromMyTodos");
    } else {
      resetToDefault();
    }
  }, []);

  return (
    <>
      <UploadStatusFloatingIcon
        uploadStatuses={downloadStatuses}
        isUpload={false}
        onCancelUpload={(id) => {
          setDownloadStatuses((prev: any) => {
            const updated = { ...prev };
            delete updated[id];
            return updated;
          });
        }}
      />
      {selectedAction === "Upload Records" ? (
        <RORUploadRecordTabIndex
          editorData={selectedRowData}
          SelectedRowsDataTo={selectedIds}
          close={handleCloseModalNew}
        />
      ) : (
        <div className="main_wrapper_section appoinment_wrapper mt-3 fade-in-left">
          <Snackbar
            open={snackbarOpen}
            message={snackbarMessage}
            onClose={() => setSnackbarOpen(false)}
            severity={error}
          />
          <Loader isLoading={loading} />
          <Container fluid className="px-5">
            <Row className="g-3">
              {" "}
              <Col md={2}>
                <Card
                  className={`h-100 todocard1 ${
                    activeCard == "Overdue" ? "active" : ""
                  }`}
                  style={{
                    backgroundColor: "#ffeae9",
                    borderRadius: "5px",
                    border: "1px solid #FEA1A1",
                  }}
                  onClick={() => {
                    setActiveCard("Overdue");
                    setActiveListName("Overdue List (Today)");
                    handleCardClick(
                      RECORD_REVIEWER_SUMMARY_CODES.OVERDUE_TODAY,
                    );
                    setActiveSubCard("Today");
                  }}
                >
                  <Card.Body className="d-flex flex-column justify-content-between p-1">
                    <div className="d-flex justify-content-between align-items-center ">
                      <Card.Title
                        style={{
                          color: "#FF6D6D",
                          fontSize: "14px",
                          fontWeight: "600",
                          marginBottom: "0px",
                        }}
                      >
                        Overdue
                      </Card.Title>
                      <span
                        className="material-symbols-outlined"
                        style={{ color: "#fe6767" }}
                      >
                        timer
                      </span>
                    </div>
                    <div className="d-flex justify-content-start">
                      <div
                        onClick={(e) => {
                          e.stopPropagation();
                          handleCardClick(
                            RECORD_REVIEWER_SUMMARY_CODES.OVERDUE_NEARDUE,
                          );
                          setActiveSubCard("Near");
                          setActiveCard("Overdue");
                          setActiveListName("Overdue List (Near Due)");
                        }}
                        style={{
                          cursor: "pointer",
                          borderRight: "1px solid transparent",
                          background:
                            "linear-gradient(to bottom, transparent 10%, #E5B7B7 10%, #E5B7B7 90%, transparent 90%) right / 1px 100% no-repeat",
                        }}
                        className={`borderRight px-1 sub-section-1 ${
                          activeSubCard == "Near" ? "active" : ""
                        }`}
                      >
                        <div style={{ fontSize: "11px", color: "#000" }}>
                          Near Due
                        </div>
                        <div
                          style={{
                            fontSize: "15px",
                            color: "#fe6767",
                            fontWeight: "600",
                          }}
                        >
                          {animatedPendingOverdue}
                        </div>
                      </div>
                      <div
                        onClick={(e) => {
                          e.stopPropagation();
                          handleCardClick(
                            RECORD_REVIEWER_SUMMARY_CODES.OVERDUE_TODAY,
                          );
                          setActiveSubCard("Today");
                          setActiveCard("Overdue");
                          setActiveListName("Overdue List (Today)");
                        }}
                        style={{
                          cursor: "pointer",
                          borderRight: "1px solid transparent",
                          background:
                            "linear-gradient(to bottom, transparent 10%, #E5B7B7 10%, #E5B7B7 90%, transparent 90%) right / 1px 100% no-repeat",
                        }}
                        className={`borderRight px-1 sub-section-1 ${
                          activeSubCard == "Today" ? "active" : ""
                        }`}
                      >
                        <div style={{ fontSize: "11px", color: "#000" }}>
                          Today
                        </div>
                        <div
                          style={{
                            fontSize: "15px",
                            color: "#fe6767",
                            fontWeight: "600",
                          }}
                        >
                          {animatedTodayOverdue}
                        </div>
                      </div>
                      <div
                        onClick={(e) => {
                          e.stopPropagation();
                          handleCardClick(
                            RECORD_REVIEWER_SUMMARY_CODES.OVERDUE,
                          );
                          setActiveSubCard("OVDU");
                          setActiveCard("Overdue");
                          setActiveListName("Overdue List (Past Overdue)");
                        }}
                        style={{
                          cursor: "pointer",
                        }}
                        className={`px-1 sub-section-1 ${
                          activeSubCard == "OVDU" ? "active" : ""
                        }`}
                      >
                        <div style={{ fontSize: "11px", color: "#000" }}>
                          Overdue
                        </div>
                        <div
                          style={{
                            fontSize: "15px",
                            color: "#fe6767",
                            fontWeight: "600",
                          }}
                        >
                          {animatedOverdue}
                        </div>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
              <Col md={2}>
                <Card
                  className={`h-100 todocard2 ${
                    activeCard == "ROR's" ? "active" : ""
                  }`}
                  style={{
                    backgroundColor: "#FCECBE",
                    borderRadius: "5px",
                    cursor: "pointer",
                    border: "1px solid #E6C872",
                  }}
                 
                  onClick={(e) => {
                    e.stopPropagation();
                    // const [start, end] = getCurrentMonthRange();
                    // setDateRange([start, end]);
                  handleCardClick(
                      RECORD_REVIEWER_SUMMARY_CODES.TOTAL_REVIEWS_PENDING,
                    );
                    setActiveCard("ROR's");
                     setActiveListName("ROR's List (Pending)");
                    setActiveSubCard("");
                  }}
                >
                  <Card.Body className="d-flex flex-column justify-content-between p-1">
                    <div className="d-flex justify-content-between align-items-center ">
                      <Card.Title
                        style={{
                          color: "#9C6F16",
                          fontSize: "14px",
                          fontWeight: "600",
                        }}
                      >
                        ROR's
                      </Card.Title>
                      <span
                        className="material-symbols-outlined"
                        style={{ color: "#9b6d15" }}
                      >
                        draft
                      </span>
                    </div>
                    {/* <div
                      style={{
                        color: "#9b6d15",
                        fontSize: "1.1rem",
                        fontWeight: "600",
                      }}
                    >
                      {animatedDraftReview}
                    </div> */}


                     <div className="d-flex justify-content-start">
                      <div
                        onClick={(e) => {
                          e.stopPropagation();
                          // const [start, end] = getCurrentMonthRange();
                          // setDateRange([start, end]); // prevent card click
                          handleCardClick(
                            RECORD_REVIEWER_SUMMARY_CODES.TOTAL_REVIEWS_PENDING,
                          );
                          setActiveCard("ROR's");
                          setActiveListName("ROR's List (Pending)");
                          setActiveSubCard("RORP");
                        }}
                        className={`px-1 ${
                          activeSubCard == "RORP" ? "active" : ""
                        }`}
                        style={{
                          borderRight: "1px solid transparent",
                          padding: "0px 3px 0px 0px",
                          background:
                            "linear-gradient(to bottom, transparent 10%, #9C6F16 10%, #9C6F16 90%, transparent 90%) right / 1px 100% no-repeat",
                        }}
                      >
                        <div style={{ fontSize: "11px", color: "#9C6F16" }}>
                          Pending
                        </div>
                        <div
                          style={{
                            fontSize: "15px",
                            color: "#9C6F16",
                            fontWeight: "600",
                          }}
                        >
                          {animatedPendingReview}
                        </div>
                      </div>
                      <div
                       onClick={(e) => {
                          e.stopPropagation();
                          // const [start, end] = getCurrentMonthRange();
                          // setDateRange([start, end]); // prevent card click
                          handleCardClick(
                      RECORD_REVIEWER_SUMMARY_CODES.DRAFT_REVIEWS,
                    );
                    setActiveCard("ROR's");
                    setActiveListName("ROR's List (Preliminary)");
                    setActiveSubCard("RORD");
                        }}
                     
                        className={`px-1 ${
                          activeSubCard == "RORD" ? "active" : ""
                        }`}
                        // style={{
                        //   borderRight: "1px solid transparent",
                        //   padding: "0px 3px 0px 0px",
                        //   background:
                        //     "linear-gradient(to bottom, transparent 10%, #9C6F16 10%, #9C6F16 90%, transparent 90%) right / 1px 100% no-repeat",
                        // }}
                      >
                        <div style={{ fontSize: "11px", color: "#9C6F16" }}>
                          Preliminary
                        </div>
                        <div
                          style={{
                            fontSize: "15px",
                            color: "#9C6F16",
                            fontWeight: "600",
                          }}
                        >
                          {animatedDraftReview}
                        </div>
                      </div>
                      </div>
                  </Card.Body>
                </Card>
              </Col>
              <Col md={2}>
                <Card
                  className={`h-100 todocard4 ${
                    activeCard == "Total ROR's" ? "active" : ""
                  }`}
                  style={{
                    backgroundColor: "#E9E5FE",
                    borderRadius: "5px",
                    border: "1px solid #9C8CEE",
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    // const [start, end] = getCurrentMonthRange();
                    // setDateRange([start, end]);
                    setActiveCard("Total ROR's");
                     setActiveListName("Total ROR's List (In Review)");
                    handleCardClick(
                      RECORD_REVIEWER_SUMMARY_CODES.TOTAL_INREVIEWS,
                    );
                    setActiveSubCard("RORP");
                  }}
                >
                  <Card.Body className="d-flex flex-column justify-content-between p-1">
                    {/* Header Row */}
                    <div className="d-flex justify-content-between align-items-center ">
                      <Card.Title
                        style={{
                          color: "#684fe5",
                          fontSize: "14px",
                          fontWeight: "600",
                        }}
                      >
                        Total ROR's
                      </Card.Title>
                      <span
                        className="material-symbols-outlined"
                        style={{ color: "#684fe5" }}
                      >
                        early_on
                      </span>
                    </div>

                    {/* Two-line details */}
                    <div className="d-flex justify-content-start">
                      <div
                        onClick={(e) => {
                          e.stopPropagation();
                          // const [start, end] = getCurrentMonthRange();
                          // setDateRange([start, end]); // prevent card click
                          handleCardClick(
                            RECORD_REVIEWER_SUMMARY_CODES.TOTAL_INREVIEWS,
                          );
                          setActiveCard("Total ROR's");
                          setActiveListName("Total ROR's List (In Review)");
                          setActiveSubCard("ROIN");
                        }}
                        className={`px-1 ${
                          activeSubCard == "ROIN" ? "active" : ""
                        }`}
                        style={{
                          borderRight: "1px solid transparent",
                          padding: "0px 3px 0px 0px",
                          background:
                            "linear-gradient(to bottom, transparent 10%, #C3BAF2 10%, #C3BAF2 90%, transparent 90%) right / 1px 100% no-repeat",
                        }}
                      >
                        <div style={{ fontSize: "11px", color: "#684fe5" }}>
                          In Review
                        </div>
                        <div
                          style={{
                            fontSize: "15px",
                            color: "#684fe5",
                            fontWeight: "600",
                          }}
                        >
                          {animatedInReview}
                        </div>
                      </div>
                      <div
                        onClick={(e) => {
                          e.stopPropagation();
                          // const [start, end] = getCurrentMonthRange();
                          // setDateRange([start, end]);
                          handleCardClick(
                            RECORD_REVIEWER_SUMMARY_CODES.TOTAL_REVIEWS_COMPLETED,
                          );
                          setActiveCard("Total ROR's");
                          setActiveListName("Total ROR's List (Completed)");
                          setActiveSubCard("RORC");
                        }}
                        style={{
                          borderRight: "1px solid transparent",
                          padding: "0px 3px 0px 0px",
                          background:
                            "linear-gradient(to bottom, transparent 10%, #C3BAF2 10%, #C3BAF2 90%, transparent 90%) right / 1px 100% no-repeat",
                        }}
                        className={`px-1 ${
                          activeSubCard == "RORC" ? "active" : ""
                        }`}
                      >
                        <div style={{ fontSize: "11px", color: "#684fe5" }}>
                          Completed
                        </div>
                        <div
                          style={{
                            fontSize: "15px",
                            color: "#684fe5",
                            fontWeight: "600",
                          }}
                        >
                          {animatedCompletedReview}
                        </div>
                      </div>
                      <div
                        onClick={(e) => {
                          e.stopPropagation();
                          // const [start, end] = getCurrentMonthRange();
                          // setDateRange([start, end]);
                          handleCardClick(
                            RECORD_REVIEWER_SUMMARY_CODES.APPOINTMENT_CANCELLED,
                          );
                          setActiveCard("Total ROR's");
                          setActiveListName("Total ROR's List (Canceled)");
                          setActiveSubCard("RORN");
                        }}
                        style={{
                          padding: "0px 3px 0px 0px",
                        }}
                        className={`px-1 ${
                          activeSubCard == "RORN" ? "active" : ""
                        }`}
                      >
                        <div style={{ fontSize: "11px", color: "#684fe5" }}>
                          Canceled
                        </div>
                        <div
                          style={{
                            fontSize: "15px",
                            color: "#684fe5",
                            fontWeight: "600",
                          }}
                        >
                          {animatedTotalAppointmentCancelled}
                        </div>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
              {/* <Col md={2}>
                <Card
                  className={`h-100 todocard3 ${
                    activeCard == "ROR Not Initated" ? "active" : ""
                  }`}
                  style={{
                    backgroundColor: "#D6F2FF",
                    borderRadius: "5px",
                    border: "1px solid #99CEE8",
                  }}
                  onClick={() => {
                    handleCardClick(
                      RECORD_REVIEWER_SUMMARY_CODES.NOT_INITIATED,
                    );
                    setActiveCard("ROR Not Initated");
                    setActiveListName("ROR Not Initated List (Total)");
                    setActiveSubCard("RTOT");
                  }}
                >
                  <Card.Body className="d-flex flex-column justify-content-between p-1">
                    <div className="d-flex justify-content-between align-items-center ">
                      <Card.Title
                        style={{
                          color: "#308F9E",
                          fontSize: "14px",
                          fontWeight: "600",
                        }}
                      >
                        ROR Not Initated
                      </Card.Title>
                      <span
                        className="material-symbols-outlined"
                        style={{ color: "#308F9E" }}
                      >
                        play_disabled
                      </span>
                    </div>

                    <div className="d-flex justify-content-start forTwoSection">
                      <div
                        onClick={(e) => {
                          e.stopPropagation();

                          handleCardClick(
                            RECORD_REVIEWER_SUMMARY_CODES.NOT_INITIATED,
                          );
                          setActiveCard("ROR Not Initated");
                          setActiveListName("ROR Not Initated List (Total)");
                          setActiveSubCard("RTOT");
                        }}
                        style={{
                          borderRight: "1px solid transparent",
                          padding: "0px 20px 0px 0px",
                          background:
                            "linear-gradient(to bottom, transparent 10%, #308F9E 10%, #308F9E 90%, transparent 90%) right / 1px 100% no-repeat",
                        }}
                        className={`px-1 ${
                          activeSubCard == "RTOT" ? "active" : ""
                        }`}
                      >
                        <div style={{ fontSize: "11px", color: "#308F9E" }}>
                          Total
                        </div>
                        <div
                          style={{
                            color: "#308F9E",
                            fontSize: "1.1rem",
                            fontWeight: "600",
                          }}
                        >
                          {animatedRorNotInitiated}
                        </div>
                      </div>
                      <div
                        onClick={(e) => {
                          e.stopPropagation();

                          handleCardClick(
                            RECORD_REVIEWER_SUMMARY_CODES.NOT_SCHEDULED_OVERDUE,
                          );
                          setActiveCard("ROR Not Initated");
                          setActiveListName("ROR Not Initated List (Overdue)");
                          setActiveSubCard("ROVD");
                        }}
                        style={{
                          padding: "0px 10px 0px 0px",
                        }}
                        className={`px-1 ${
                          activeSubCard == "ROVD" ? "active" : ""
                        }`}
                      >
                        <div style={{ fontSize: "11px", color: "#308F9E" }}>
                          Overdue
                        </div>
                        <div
                          style={{
                            fontSize: "15px",
                            color: "#308F9E",
                            fontWeight: "600",
                          }}
                        >
                          {animatedNotScheduledOverdue}
                        </div>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </Col> */}
              <Col md={2}>
                <Card
                  className={`h-100 todocard9 ${
                    activeCard == "Exception" ? "active" : ""
                  }`}
                  style={{
                    backgroundColor: "#f8dcb4",
                    borderRadius: "5px",
                    border: "1px solid #EFCA93",
                  }}
                  onClick={() => {
                    handleCardClick(
                      RECORD_REVIEWER_SUMMARY_CODES.AWAITING_RESPONSE,
                    );
                    setActiveCard("Exception");
                    setActiveListName("Exception List");
                    setActiveSubCard("");
                  }}
                >
                  <Card.Body className="d-flex flex-column justify-content-between p-1">
                    <div className="d-flex justify-content-between align-items-center ">
                      <Card.Title
                        style={{
                          color: "#995911",
                          fontSize: "14px",
                          fontWeight: "600",
                        }}
                      >
                        Exception
                      </Card.Title>
                      <span
                        className="material-symbols-outlined"
                        style={{ color: "#995911" }}
                      >
                        question_mark
                      </span>
                    </div>
                    <div
                      style={{
                        color: "#995911",
                        fontSize: "1.1rem",
                        fontWeight: "600",
                      }}
                    >
                      {animatedExceptionCount}
                    </div>
                  </Card.Body>
                </Card>
              </Col>
              <Col md={2}>
                <Card
                  className={`h-100 todocard7   ${
                    activeCard == "All ROR's" ? "active" : ""
                  }`}
                  style={{
                    backgroundColor: "#ccffd5",
                    borderRadius: "5px",
                    border: "1px solid #2f9d50",
                  }}
                  onClick={() => {
                    handleCardClick(RECORD_REVIEWER_SUMMARY_CODES.ALL_RORS);
                    setActiveSubCard("");
                    setActiveListName("All ROR's List");
                    setActiveCard("All ROR's");
                  }}
                >
                  <Card.Body className="d-flex flex-column justify-content-between p-1">
                    <div className="d-flex justify-content-between align-items-center ">
                      <Card.Title
                        style={{
                          color: "#2f9d50",
                          fontSize: "14px",
                          fontWeight: "600",
                        }}
                      >
                        All ROR's
                      </Card.Title>
                      <span
                        className="material-symbols-outlined"
                        style={{ color: "#2f9d50" }}
                      >
                        checklist
                      </span>
                    </div>
                    <div
                      style={{
                        fontSize: "15px",
                        color: "#2f9d50",
                        fontWeight: "600",
                      }}
                    >
                      {animatedAllReports}
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
            <div
              className="my-3"
              style={{ background: "#0092D5", height: "2px" }}
            ></div>
            <div className="container-fluid px-2">
              <div className="mt-3 mb-3">
                <Row className="align-items-center justify-content-between mb-3">
                  <Col xs="auto" className="sectionTitle noborder pe-3">
                    {activeListName}
                  </Col>
                  <Col xs="auto">
                    <div className="d-flex align-items-center gap-2">
                      <div
                        className="date-picker-container appointment-data-range customDrodownControlDAtepicker"
                        style={{ width: "280px" }}
                      >
                        <DateRangePicker
                          label=""
                          onChange={handleDateRangeChange}
                          startDate={dateRange[0]}
                          endDate={dateRange[1]}
                          minDate={computedMinDate}
                          maxDate={computedMaxDate}
                          showResetIcon={!!dateRange[0] && !!dateRange[1]}
                          onReset={handleResetDate}
                        />
                      </div>
                      <InputGroup className="w-auto">
                        <InputGroup.Text className="px-2">
                          <span className="material-symbols-outlined text-black-50">
                            search
                          </span>
                        </InputGroup.Text>
                        <Form.Control
                          ref={inputRef}
                          aria-label="Search"
                          onChange={(e) =>
                            handleInputChange(e.target.value.trim())
                          }
                          onPaste={(e) => {
                            e.preventDefault();
                            const text = e.clipboardData.getData("text").trim();
                            handleInputChange(text);
                            if (inputRef.current) inputRef.current.value = text;
                          }}
                        />
                      </InputGroup>
                      <Button
                        className="d-flex align-items-center"
                        style={{
                          background: "none",
                          border: "none",
                          cursor: "pointer",
                          padding: "10px",
                          fontSize: "22px",
                        }}
                        onClick={handleResetFilters}
                      >
                        <span className="material-icons reset_ic0">
                          restart_alt
                        </span>
                      </Button>
                      <Dropdown as={ButtonGroup}>
                        <Dropdown.Toggle
                          variant="outline"
                          className="d-flex align-items-center btn-text-border appoinmentdropdown p-2"
                        >
                          <span className="material-symbols-outlined">
                            download
                          </span>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Item onClick={handleExportExcel}>
                            Export to Excel
                          </Dropdown.Item>
                          <Dropdown.Item onClick={handleExportPDF}>
                            Export to PDF
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>

                      {!hideForMultipleCompleted && selectedIds?.length > 0 && (
                        <AppointmentActionsDropdown
                          name="Actions"
                          options={
                            showMultipleOptions
                              ? allOptionsForMultipleSelect
                              : showCompletedSingle
                                ? allOptionsForReviewCompleted
                                : allOptions
                          }
                          value={selectedAction}
                          onChange={handleActionChange}
                        />
                      )}
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
            <div className="mb-2 container-fluid">
              <RecordReviewerEditableTable
                headers={RecordReviewerHeader}
                rows={recordReviewerData}
                isCheckbox={true}
                selectedRowIds={selectedIds}
                onSortAction={handleSortAction}
                onCheckboxSelect={handleCheckboxSelect}
                selectAll={selectAll}
                setSelectAll={setSelectAll}
                onSaveSuccess={assignReviewer}
                onAction={handleDownloadSingleFileROR}
                onCaseClick={handleCaseClick}
              />
            </div>
            <div className="d-flex justify-content-between align-items-center mt-0 mb-4 row p-0 m-0">
              {/* Display entries text on the left */}
              <div className="col-md-12">
                <div className="row">
                  <div className="col-md-6 showingData_wrapper">
                    <span>{entriesText}</span>
                  </div>
                  <div className="col-md-6">
                    <div className="d-flex flex-row-reverse ">
                      <CustomPagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={paginate}
                      />
                      <TableRowsPerPage
                        value={itemsPerPage}
                        onSelect={handleRowsPerPageChange}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Container>
          <RecordReviewerCommonDrawer
            title={drawerTitle}
            open={showActionDrawer}
            onClose={handleActionDrawer}
            placement="end"
            width={selectedAction === "Assign to Reviewer" ? "40%" : "60%"}
            height={selectedAction === "Assign to Reviewer" ? "400px" : "auto"}
            top={selectedAction === "Assign to Reviewer" ? "auto" : "175px"}
          >
            {selectedAction === "Add Notes" && (
              <RecordReviewerAddNotes
                showDrawer={showActionDrawer}
                onClose={handlecloseActionDrawer}
                caseInfoId={selectedRowData[0]?.caseInfoId}
                caseId={selectedRowData[0]?.caseId}
                isRowActionTriggered={false}
                onNotesSaved={() => {}}
                subjectQmeScheduleID={selectedRowData[0]?.subjectQmeScheduleId}
                selectedRowData={selectedRowData}
                 details = {selectedRowData[0]?.patientName + " - " + selectedRowData[0]?.caseOrExamType}
              />
            )}
            {selectedAction === "Assign to Reviewer" && (
              <AssignToRecordReviewer
                reviewerData={selectedRowData}
                showDrawer={showActionDrawer}
                onClose={handlecloseActionDrawer}
                caseInfoId={selectedRowData[0]?.caseInfoId}
                caseId={selectedRowData[0]?.caseId}
              />
            )}
          </RecordReviewerCommonDrawer>
        </div>
      )}
    </>
  );
};

export default RecordReviewerDashboard;
